import FileData from './FileData';

/**
 * 報告書タイプ
 */
export class ReportType {
    /** 報告書タイプコード */
    code = ""
    /** 報告書タイプ名 */
    name = ""

    /** 報告書テンプレートファイルファイル */
    reportTemplate = new FileData()

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<ReportType>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new ReportType(JSON.parse(JSON.stringify(this)));
    }

}
